import { Body1, Box, Button, Display5 } from '@sainsburys-tech/fable'
import { AlertCircleFilled } from '@sainsburys-tech/icons'
import moment from 'moment'
import React, { useContext, useEffect, useState } from 'react'

import { useApiClient } from '../../../common/AppContext/appContext'
import ConfirmationBanner from '../../../common/components/Banners/ConfirmationBanner'
import ErrorBanner from '../../../common/components/Banners/ErrorBanner'
import { addBannerMessage } from '../../../common/Context/commonDispatch'
import { Context } from '../../../common/Context/context'
import { setBatchItemSoldOut } from '../../api/displayApi'
import { IBatchItemDisplay } from '../../types/IBatchItemDisplay'
import SoldOutAlertModal from './SoldOutModal'

interface IProps {
  batchItem: IBatchItemDisplay
  removeBatchItem: () => void
  refreshBatchItems: () => void
}

const BatchItemCard = (props: IProps) => {
  const { dispatch } = useContext(Context)

  const [isSoldOutModalOpen, setIsSoldOutModalOpen] = useState(false)
  const [isRemoveDisabled, setIsRemoveDisabled] = useState(false)
  const [isOperationPending, setIsOperationPending] = useState(false)

  useEffect(() => {
    if (!isOperationPending) {
      setIsRemoveDisabled(false)
    }
  }, [props.batchItem.batchItemId, isOperationPending])

  const apiClient = useApiClient()

  return (
    <Box
      className='hotfood-batch-card-wrapper hotfood-display-card-wrapper'
      data-testid={`batchitem-${props.batchItem.batchItemId}`}
    >
      <Box className='c-batch-card'>
        <div className='hotfood-display-card-header'>
          <Display5 className='hotfood-display-card-title'>
            {props.batchItem.skuName}
          </Display5>
          <Body1 className='hotfood-display-card-dispose'>
            {`Dispose at ${moment
              .utc(props.batchItem.toBeDisposedAt)
              .local()
              .format('HH.mm')}`}
          </Body1>
        </div>
        <div className='hotfood-display-card-actions'>
          <Button
            isFullWidth
            disabled={isRemoveDisabled}
            onClick={() => {
              setIsSoldOutModalOpen(true)
            }}
            testid='remove-button'
          >
            Remove
          </Button>
        </div>
        {isSoldOutModalOpen && (
          <SoldOutAlertModal
            skuName={props.batchItem.skuName}
            handleClose={() => {
              setIsSoldOutModalOpen(false)
              setIsRemoveDisabled(false)
            }}
            handleSoldOut={() => {
              setIsOperationPending(true)
              setIsRemoveDisabled(true)
              setIsSoldOutModalOpen(false)
              setBatchItemSoldOut(apiClient, {
                batchItemId: props.batchItem.batchItemId,
              })
                .then((res) => {
                  setIsOperationPending(false)
                  if (res.isSuccess) {
                    props.removeBatchItem()
                    dispatch(
                      addBannerMessage(
                        <ConfirmationBanner
                          message={`'${props.batchItem.skuName}' have been successfully registered as sold out.`}
                        />,
                      ),
                    )
                  } else {
                    setIsRemoveDisabled(false)
                    props.refreshBatchItems()
                    dispatch(
                      addBannerMessage(
                        <ErrorBanner
                          message={`An error occurred whilst attempting to set the '${props.batchItem.skuName}' batch as sold out - ${res.message}`}
                          icon={<AlertCircleFilled />}
                        />,
                      ),
                    )
                  }
                })
                .catch((e) => {
                  setIsOperationPending(false)
                  setIsRemoveDisabled(false)
                  props.refreshBatchItems()
                  dispatch(
                    addBannerMessage(
                      <ErrorBanner
                        message={`An error occurred whilst attempting to set the '${props.batchItem.skuName}' batch as sold out - ${(e as Error).message}`}
                        icon={<AlertCircleFilled />}
                      />,
                    ),
                  )
                })
            }}
            isOpen={isSoldOutModalOpen}
          />
        )}
      </Box>
    </Box>
  )
}

export default BatchItemCard
